import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { AuthShell, Field, inputClass } from "@/components/AuthShell";
import { GoogleButton, OrDivider } from "@/components/GoogleButton";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back to MyssticChat ✨");
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Welcome Back"
      subtitle="Sign in to view your monthly guidance"
      footer={<>New to MyssticChat? <Link to="/register" className="text-amber-300 hover:text-amber-200">Create an account</Link></>}
    >
      <GoogleButton />
      <OrDivider />
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email Address">
          <input data-testid="login-email-input" type="email" required value={email}
            onChange={(e) => setEmail(e.target.value)} className={inputClass} placeholder="you@example.com" />
        </Field>
        <Field label="Password">
          <input data-testid="login-password-input" type="password" required value={password}
            onChange={(e) => setPassword(e.target.value)} className={inputClass} placeholder="••••••••" />
        </Field>
        <div className="text-right -mt-1">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-amber-300/80 hover:text-amber-200">Forgot password?</Link>
        </div>
        {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
        <button data-testid="login-submit-button" type="submit" disabled={loading}
          className="btn-gold rounded-full w-full py-3.5 flex items-center justify-center gap-2 disabled:opacity-60">
          <LogIn size={18} /> {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </AuthShell>
  );
}
